import { Spin } from 'antd';

const Loader = () => {
  return (
    <div className="py-24 flex justify-center">
      <Spin />
    </div>
  );
};

export default Loader;
